import { useSelector } from 'react-redux';
import { getX50PlayerAmount } from '../selectors';
import { SectorColors } from '../utils';
import { IStore } from 'store/interface';

export const useFactorControl = (color: SectorColors) =>
  useSelector<IStore, { amount: number; disabled: boolean }>(state =>
    getX50PlayerAmount(state, color)
  );
